import React from 'react';
import {useTranslation} from "react-i18next";
import Graphic from "../../../../resources/images/article.svg";
import EmptyState from "../../feeback/State/Empty";

const Empty = () => {
    const {t} = useTranslation();

    return (
        <EmptyState
            title={t('site_article_empty_title')}
            textI18Key='site_article_empty_text'
            graphic={Graphic}
        />
    );

};

export default Empty;